import { useMemo } from 'react';

import { useMemberId } from '@trello/authentication';
import { isEmbeddedInAtlassian } from '@trello/browser';
import { checkIsTemplate, isPluginEnabled } from '@trello/business-logic/board';
import { useBoardMembers } from '@trello/business-logic-react/board';

// eslint-disable-next-line no-restricted-imports
import { Controller } from 'app/scripts/controller';
import { LegacyPowerUps } from 'app/scripts/data/legacy-power-ups';
import { useAboutThisBoardFragment } from './AboutThisBoardFragment.generated';

export function useAboutThisBoardModal(boardId: string) {
  const memberId = useMemberId();
  const { data: board } = useAboutThisBoardFragment({
    from: { id: boardId },
    optimistic: true,
  });

  const { isMember } = useBoardMembers(boardId);

  const idMemberCreator = board?.idMemberCreator;
  const premiumFeatures = board?.premiumFeatures;
  const boardPlugins = board?.boardPlugins;
  const isTemplate = board?.prefs?.isTemplate ?? false;
  const permissionLevel = board?.prefs?.permissionLevel;
  const description = board?.desc;
  const closed = board?.closed;

  const isBoardMember = !!isMember(memberId);

  const isBoardTemplate = useMemo(() => {
    return checkIsTemplate({
      isTemplate,
      permissionLevel,
      premiumFeatures,
    });
  }, [isTemplate, permissionLevel, premiumFeatures]);

  const isBoardPluginsEnabled = useMemo(() => {
    return isPluginEnabled(LegacyPowerUps.readMe, {
      boardPlugins: boardPlugins ?? [],
    });
  }, [boardPlugins]);

  const embeddedInAtlassian = useMemo(() => {
    return isEmbeddedInAtlassian();
  }, []);

  const wouldRender =
    idMemberCreator !== memberId &&
    // TODO don't use Controller for this... :)
    Controller.isFirstTimeViewingBoard &&
    !!description &&
    !closed &&
    (!isBoardTemplate || (isBoardTemplate && !isBoardMember)) &&
    !isBoardPluginsEnabled &&
    !embeddedInAtlassian;

  return {
    wouldRender,
  };
}
